module.exports = __webpack_public_path__ + "img/finance1.11f60d0f.jpg";